var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data.open
    ? _c("div", { staticClass: "info-block" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-default closeBtn",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.data.open = false
                },
              },
            },
            [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("p", [
                _vm._v("Запрос с проекта "),
                _c("span", { staticClass: "badge badge-info fs-14" }, [
                  _vm._v(
                    _vm._s(_vm.$AllProjects[_vm.data.data.api_site_id]?.title)
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("телефон: "),
                _c("strong", { staticClass: "fs-14" }, [
                  _vm._v(_vm._s(_vm.data.data.phone)),
                ]),
              ]),
              _vm._v(" "),
              _vm.data.data.client_black_list
                ? _c("p", [
                    _c("span", { staticClass: "badge badge-danger" }, [
                      _vm._v("Черный список"),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.data.drug_id
                ? _c("p", [_vm._v(_vm._s(_vm.data.data.drug_id))])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.data.drug
                ? _c("p", { staticClass: "fs-18" }, [
                    _vm._v(_vm._s(_vm.data.data.drug.title)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.data.page
                ? _c("p", [
                    _vm._v("страница: "),
                    _c(
                      "a",
                      { attrs: { target: "_blank", href: _vm.data.data.page } },
                      [_vm._v(_vm._s(_vm.data.data.page))]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "mt-1 text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success btn-xs",
                    attrs: { type: "button" },
                    on: { click: _vm.createOrder },
                  },
                  [_vm._v("Создать заявку с текущим клиентом\n        ")]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.phoneNum && _vm.sip
                ? [
                    _c("p", [
                      _vm._v("Совершить звонок с номера: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.phoneNum.connected_phone.display_phone)
                        ),
                      ]),
                      _vm._v(
                        " (" +
                          _vm._s(_vm.phoneNum.connected_phone.description) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("SIP: " + _vm._s(_vm.sip.sip_login))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-1 text-right" },
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Позвонить",
                            type: "button",
                            loading: _vm.btnLoading,
                            color: _vm.$constants.SUCCESS_COLOR,
                            onClick: () => _vm.makePhoneCall(),
                            className: "btn btn-outline-success",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-primary" }, [
      _c("h5", [_vm._v("Запрос на звонок клиенту с сайта! (25 секунд)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }